import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Login from "./Pages/Login/Login";
import Home from "./Pages/Home/Home";
import Admin from "./Pages/Panel/Admin";
import Categories from "./Pages/Categories/Categories";
import Countries from "./Pages/Countries/Countries";
import Authors from "./Pages/Authors/Authors";
import Articles from "./Pages/Articels/Articles";
import Settings from "./Pages/Settings/Settings";
import Article from "./Pages/Article/Article";
import Sign from "./Pages/Auth/Sign";
import ArticlePage from "./subpage/ArticlePage";
import SubSearch from "./Components/subSearch/SubSearch"
import Media from "./Components/Panel/media/Media";
import MediaPage from "./subpage/MediaPage";
import Member from "./Pages/Member/Member";
import Addarticle from "./Pages/Articels/Addarticle";
import Whoare from "./Components/Home/Whoare/Whoare";
import Archive from "./Components/Home/Archive/Archive";
import Magazinepage from "./Components/Panel/Magazinepage/Magazinepage";
import Mostaqlon from "./Components/Home/mostaqlon/Mostaqlon";
import Details from "./subpage/Details";
import FormPage from "./Pages/Form/Formpage";
function App() {
  return (
    <>
      <BrowserRouter path="/">
        <Routes>
          <Route path="/sign" exact element={<Sign />}></Route>
          <Route path="/" exact element={<FormPage />}></Route>
          <Route path="/home" exact element={<Home />}></Route>
          <Route path="/article/:id" exact element={<Article />}></Route>
          <Route path="/articles" element={<ArticlePage />} /> 
          <Route path="/details/:id" element={<Details />} />       
          <Route path="/media" element={<MediaPage />} />
          <Route path="/mostqlon" element={<Mostaqlon />} />
           <Route path="/subsearch" exact element={<SubSearch />}></Route>
           <Route path="/archive" exact element={<Archive />}></Route>
           <Route path="/whoare" exact element={<Whoare />}></Route>
        
          <Route path="/admin" element={<Admin />}>
            <Route path="categories" element={<Categories />} />
            <Route path="countries" element={<Countries />} />
            <Route path="authors" element={<Authors />} />
            <Route path="member" element={<Member />} />
            <Route path="articles" element={<Articles />} />

            <Route path="newArticle" element={<Addarticle />} />
            <Route path="newArticle/:id" element={<Addarticle />} />
            <Route path="media" element={<Media />} />
            <Route path="magazinepage" element={<Magazinepage />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
